document.addEventListener("turbolinks:load", () => {
    const $body = $('body');
    if (!$body.hasClass('reports')) return;
});
